import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BroadcastOnPersonalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"broadcast_on_personal"}/>
}
